/**
 * A guided tour already loaded and translated. The runner never knows where it came from: the
 * source (the manual authoring channel) is a concern of whoever loads it.
 */
export interface Tour {
  /** Stable identifier, e.g. `iam.account` or `general.list`; it is what `meta.tours` stores once seen. */
  id: string;
  /** Shown to the user when they pick this tour to replay. */
  title: string;
  /**
   * Screen kind of a general tour, which targets roles and runs on every screen of that kind;
   * `null` for the own tour of one screen, which targets full `data-tour` values.
   */
  screen: TourScreen | null;
  steps: TourStep[];
}

export const TOUR_SCREEN = { LIST: 'list', FORM: 'form' } as const;

export type TourScreen = (typeof TOUR_SCREEN)[keyof typeof TOUR_SCREEN];

export interface TourStep {
  /**
   * The element to highlight: the value of its `data-tour` attribute (e.g. `iam.account.table`),
   * or, in a general tour, only its role (`table`).
   */
  target: string;
  title: string;
  text: string;
}
